import { IntlShape } from 'react-intl';
import {Relationship, RelationshipState} from 'types';
import { getFormattedDate } from 'utils/date';

export const hasAdminAccessOnRelationship = (relationship: Relationship): boolean =>
  !!relationship.user?.familyAccess && relationship.user.mainUserAccess;

export const getRelationshipAccessLabel = (
  relationship: Relationship,
  intl: IntlShape,
): string => {
  if (
    relationship.state === RelationshipState.CONNECTED &&
    relationship.user
  ) {
    return hasAdminAccessOnRelationship(relationship)
      ? intl.formatMessage({ id: 'relationship.access.admin' })
      : intl.formatMessage({ id: 'relationship.access.classic' });
  }

  return '';
};

export const getRelationshipStateLabel = (
  relationship: Relationship,
  intl: IntlShape,
): string =>
  intl.formatMessage(
    { id: `relationship.state.${relationship.state}` },
    { createdDate: getFormattedDate(relationship.created) },
  );
